import React from "react";
import "../css/contactCard.css";
import instaicon from "../assets/socialIcons/insta.png";
import fbicon from "../assets/socialIcons/fb2.png";
import emailicon from "../assets/socialIcons/mail.png";
import linkdinicon from "../assets/socialIcons/linkdin.png";

export default function ContactCard(props) {
  const contact = props.contact;
  return (
    <>
      <li>
        <div className="cardcon">
          <img
            src={contact.image}
            className="card__imagecon"
            alt={contact.name}
          />
          <div className="card__overlaycon">
            <div className="card__headercon">
              <img className="card__thumbcon" src={contact.image} alt="" />
              <div className="card__header-textcon">
                <h3 className="card__titlecon">{contact.name}</h3>
                <span className="card__statuscon">{contact.post}</span>
              </div>
            </div>

            <div className="card__descriptioncon">
              <div className="MobileNumber">
                <span>Phone: {contact.phone}</span>
              </div>

              <div className="">
                <a
                  target="_blank"
                  href={"mailto:" + contact.ant_userid + "@antaragni.in"}
                  class="icon"
                  rel="noopener"
                >
                  <img src={emailicon} alt="fb-icon" />
                </a>
                {/* <a target="_blank" href={contact.insta} rel="noreferrer">
                  <img src={instaicon} alt="insta" />
                </a> */}
                <a target="_blank" href={contact.fb_userid} rel="noreferrer">
                  <img src={fbicon} alt="fb-icon" />
                </a>
                <a target="_blank" href={contact.linkedin} rel="noreferrer">
                  <img src={linkdinicon} alt="fb-icon" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </li>
    </>
  );
}
